import * as z from "zod";

/**
 * hexColorSchema validates a 3- or 6-digit hex color string (`#abc` or `#aabbcc`), matching the
 * color pattern the API persists, so a caller-supplied color is rejected at the mutation boundary
 * before a write sees it. The palette it validates against lives one level down in
 * `@mountaya/elements/style` (the lively colors are all 6-digit hexes that satisfy it), and the
 * schema is the studio's because validating a write is a studio concern: the rendering family
 * states the vocabulary, the studio validates a write against it.
 */
export const hexColorSchema = z.string().regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
